import React from "react";
import droneTarimGorseli from "../../assets/görsel.png";
import pattern from "../../assets/pattern.png";

export const HeroSection: React.FC = () => {
  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center overflow-hidden bg-white"
    >
      <div
        className="absolute inset-0 opacity-20 bg-center bg-cover"
        style={{ backgroundImage: `url(${pattern})` }}
      />

      <div className="absolute inset-0 bg-white/70" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div className="space-y-8 text-center lg:text-left">
            <div className="inline-flex items-center justify-center lg:justify-start gap-2 px-4 py-2 bg-black/5 backdrop-blur border border-black/10 rounded-full mx-auto lg:mx-0">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
              <span className="text-green-700 font-medium text-sm">
                29-30 Ocak 2026
              </span>
            </div>

            <div className="space-y-4">
              <h1 className="font-bold text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl leading-none text-slate-900">
                Su
                <br />
                Hackathonu
              </h1>
              <div className="w-20 sm:w-24 h-1 bg-green-500 rounded-full mx-auto lg:mx-0" />
            </div>

            <p className="text-slate-600 text-base sm:text-lg md:text-xl leading-relaxed max-w-xl mx-auto lg:mx-0">
              Su kaynaklarını korumak, akıllı sulama sistemleri geliştirmek ve
              sürdürülebilir tarım için yenilikçi çözümler üretin.
            </p>

            <div className="pt-4">
              <div className="inline-flex items-center gap-3 px-6 py-3 bg-green-50 border border-green-200 rounded-2xl">
                <div className="w-3 h-3 bg-green-500 rounded-full" />
                <span className="text-green-800 font-semibold text-base">
                  Etkinlik Tamamlandı
                </span>
              </div>
            </div>

            <div className="pt-6 flex flex-col sm:flex-row gap-3">
              <a
                href="#gallery"
                className="
                  inline-flex
                  items-center
                  justify-center
                  gap-3
                  w-full
                  sm:w-auto
                  px-8
                  py-4
                  rounded-full
                  text-base
                  sm:text-lg
                  font-semibold
                  text-white
                  bg-green-600
                  hover:bg-green-700
                  transition-all
                  duration-300
                  shadow-lg
                  no-underline
                "
              >
                Galeriyi Gör
                <svg
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div className="relative hidden lg:flex justify-center mt-10 lg:mt-0">
            <img
              src={droneTarimGorseli}
              alt="Drone"
              className="
                w-64
                sm:w-80
                md:w-96
                lg:w-[28rem]
                xl:w-[32rem]
                drop-shadow-xl
                opacity-95
                animate-floating
              "
            />
          </div>
        </div>
      </div>
    </section>
  );
};
